import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { TestTube2, X } from "lucide-react";

// A high-visibility floating "Book a Test" pill that follows the visitor
// across every non-admin page so bookings are always one tap away.
const BookTestFAB = () => {
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(false);

  // Hide on admin, auth, and pages where the primary CTA is a booking flow
  // (avoid stacking on top of a Book button that already dominates the screen).
  const hideOn = [
    pathname.startsWith("/admin"),
    pathname.startsWith("/auth/"),
    pathname === "/home-collection",
    pathname === "/tests",
    pathname.startsWith("/tests/"),
  ].some(Boolean);

  useEffect(() => {
    setDismissed(false); // reset on route change so it re-appears
  }, [pathname]);

  if (hideOn || dismissed) return null;

  return (
    <div
      data-testid="book-test-fab"
      className="fixed z-40 left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:right-4 bottom-20 md:bottom-32 pointer-events-none"
    >
      <div className="pointer-events-auto relative">
        {/* Pulsing halo */}
        <span aria-hidden className="absolute inset-0 rounded-full bg-dl-blue/30 animate-ping" />
        <Link
          to="/home-collection"
          className="relative inline-flex items-center gap-2 bg-gradient-to-r from-dl-blue to-blue-700 text-white rounded-full pl-3 pr-5 py-2.5 shadow-2xl shadow-blue-500/40 ring-2 ring-white hover:scale-[1.03] active:scale-95 transition"
          aria-label="Book a test now"
        >
          <span className="grid place-items-center h-8 w-8 rounded-full bg-white/15 backdrop-blur">
            <TestTube2 className="h-4 w-4" />
          </span>
          <span className="text-sm font-bold">Book a Test</span>
          <span className="hidden sm:inline text-[10px] font-semibold bg-amber-300 text-slate-900 rounded-full px-1.5 py-0.5 ml-1">FREE PICKUP</span>
        </Link>
        <button
          onClick={() => setDismissed(true)}
          aria-label="Hide book a test button"
          className="absolute -top-1.5 -right-1.5 h-5 w-5 rounded-full bg-white text-slate-500 hover:text-slate-800 border border-slate-200 grid place-items-center shadow"
        >
          <X className="h-3 w-3" />
        </button>
      </div>
    </div>
  );
};

export default BookTestFAB;
